export class ApiError extends Error {
  constructor (public code: number, message = '') {
    super(message || `Response Status ${code}`);
  }
}
